import { apiUrl, fetchJson } from '../apiBase';

let meCache = null; // { ok: boolean, data: object|null }
let meInFlight = null; // Promise resolving to current fetch result

function hasAuthenticatedAdmin(entry) {
  return !!(entry && entry.ok && entry.data && entry.data.admin_user);
}

export async function getMeCached(force = false) {
  // Only reuse a positive authenticated cache. Avoid persisting false negatives
  // from timing races during login transitions.
  if (!force && hasAuthenticatedAdmin(meCache)) return meCache;
  if (!force && meInFlight) return meInFlight;
  meInFlight = (async () => {
    try {
      const res = await fetchJson(apiUrl('/admin/me'));
      const ok = !!res?.ok;
      let data = null;
      if (ok) {
        try { data = await res.json(); } catch (_) { data = null; }
        if (data && data.admin_user) {
          const au = data.admin_user;
          const schoolId = au.school_id || au.school || au.school_name;
          data = { ...data, admin_user: { ...au, school_id: schoolId } };
        }
      }
      const current = { ok, data };
      meCache = hasAuthenticatedAdmin(current) ? current : null;
      return current;
    } finally {
      meInFlight = null;
    }
  })();
  return meInFlight;
}

export function clearMeCache() {
  meCache = null;
  meInFlight = null;
}
